<template>
	<div class="contBox">
		<div class="title">
			<p>
				<span style="color:#298BEF;">商品名片</span>
				/选择场景
			</p>
		</div>
		<!-- 新建-->
		<div class="addbox">
			<ul>
				<li class="blankWhit" @click="whitAdd">
					<i class="el-icon-plus iconsAdd"></i>
					<p>空白模板</p>
				</li>
				<!-- 模板 -->
				<li v-for="(i, index) in list" :key="index" @click="Editor(i)">
					<div class="mb">
						<div class="leftmb-img"><img style="width: 100%; height: auto; object-fit: fill;" :src="i.pic_name" /></div>
						<div class="Rightmb-text">
							<h3>{{ i.name }}</h3>
							<p v-html="i.content" class="p1"></p>
							<p v-html="i.contents" class="p2"></p>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import editor from '../views/kindeditor.vue'; // 国控
export default {
	name: 'GoodsCodeAdd',
	components: { editor },
	data() {
		return {
			list: [
				{
					//  ../assets/imgs/jiu.png
					pic_name: require('../assets/imgs/Alcohol.png'),
					img: '../assets/imgs/Alcohol.png',
					content: '展示商品信息、使用方法、保修',
					contents: '信息以及联系方式',
					name: '酒品信息',
					template_id: 3,
					imgUrl: require('../assets/imgs/jiu.png'),
					html: `<p style="color:#848484;text-align:center;white-space:normal;font-size:24px;">
	<p style="color:#848484;text-align:center;white-space:normal;font-size:24px;">
		奔富BIN407红葡萄酒
	</p>
	<p style="color:#848484;text-align:center;white-space:normal;font-size:24px;">
		<span style="color:red;">299</span>&nbsp;元/瓶
	</p>
	<div class="biqbody" style="color:#848484;font-size:16px;text-align:center;white-space:normal;">
		<div class="body_bt" style="margin:16px 0px;">
			————&nbsp;商品参数&nbsp;————
		</div>
		<table border="1px" cellspacing="0" cellpadding="0" align="center" width="100%" style="color:#848484;text-align:center;height:320px;">
			<tbody>
				<tr>
					<td width="80">
						商品名称
					</td>
					<td>
						407红葡萄酒
					</td>
				</tr>
				<tr>
					<td>
						酒庄
					</td>
					<td>
						奔富酒庄
					</td>
				</tr>
				<tr>
					<td>
						产地
					</td>
					<td>
						澳大利亚
					</td>
				</tr>
				<tr>
					<td>
						葡萄产区
					</td>
					<td>
						巴罗沙谷拉顿布里麦克拉伦谷库纳瓦拉
					</td>
				</tr>
				<tr>
					<td>
						酒精度
					</td>
					<td>
						14.5%
					</td>
				</tr>
				<tr>
					<td>
						酸度
					</td>
					<td>
						6.3克/升
					</td>
				</tr>
				<tr>
					<td>
						pH
					</td>
					<td>
						3.62
					</td>
				</tr>
				<tr>
					<td>
						熟化
					</td>
					<td>
						置于法国橡木（24%全新）和美国大橡木桶 10%为全新、27%为一年陈、39%为两年陈） 熟化13个月
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="cqwei" style="color:#848484;font-size:16px;text-align:center;white-space:normal;">
		<div class="cqwei_bt" style="margin:16px 0px;">
			————&nbsp;商品参数&nbsp;————
		</div>
		<div class="cqwei_img">
			<img src="https://work.idcode.org.cn/static/styles/common/images/pic_6.png"  style="width: 300px;height: auto; margin: 0 auto; object-fit: scale-down;"/>
		</div>
	</div>
	<div class="jzjie" style="color:#848484;font-size:16px;text-align:center;white-space:normal; ">
		<div class="cjzjie_bt" style="margin:16px 0px;">
			————&nbsp;酒庄介绍&nbsp;————
		</div>
		<div class="jzjie_img">
			<img src="https://work.idcode.org.cn/static/styles/common/images/pic_7.png" style="width: 300px;height: auto; margin: 0 auto; object-fit: scale-down;"/>
		</div>
		<div class="jz_txt" style="margin:0px auto;">
			奔富酒庄（Penfolds Winery） 位于澳大利亚赫赫有名的巴罗萨产区， 是澳大利亚最著名，也是最大的葡萄酒庄， 它被人们看作是澳大利亚红酒的象征， 被称为澳大利亚葡萄酒业的贵族。在澳洲， 这是一个无人不知，无人不晓的品牌。 奔富酒庄的发展史充满传奇，有人说， 它其实是欧洲殖民者在澳大利亚开拓、发展、 定居繁衍演变史的一个缩影。 巴罗萨产区是一个相当有趣的产区， 这里密密麻麻的聚集了众多澳大利亚优秀酒庄， 他们有着各不相同的酿酒理念，有些酒庄，例如奔富、 百兔、酝思古纳华拉等崇尚酿造高品质葡萄酒的理念， 而另外一些则例如杰卡斯、利达民、 禾富这些走完全商业化的路线， 每一瓶葡萄酒均按照大众化口味来酿制， 以讨好尽多的爱酒之人。
		</div>
	</div>
</p>
<p>
	<br />
</p>`,
				},
				{
					// ../assets/imgs/jiadian.png
					pic_name: require('../assets/imgs/life.png'),
					img: '../assets/imgs/life.png',
					content: '展示示商品信息、使用方法、保修',
					contents: '信息以及联系方式',
					name: '生活电器',
					template_id: 5,
					imgUrl: require('../assets/imgs/jiadian.png'),
					html: `<p style="color:#848484;text-align:center;white-space:normal;font-size:24px;">
	小熊（Bear）加湿器
</p>
<p style="color:#848484;text-align:center;white-space:normal;font-size:24px;">
	<span style="color:red;">159</span>&nbsp;元/台
</p>
<div class="biqbody" style="color:#848484;font-size:16px;text-align:center;white-space:normal;background-color:#F0F0F0;margin:0px auto;">
	<br />
	<div class="body_bt" style="margin:16px 0px;">
		————&nbsp;商品参数&nbsp;————
	</div>
	<ul style="text-align:left;">
		<li>
			产品名称：&nbsp;小熊（Bear）加湿器
		</li>
<br />
		<li>
			商品编号：&nbsp;169786565545
		</li>
<br />
		<li>
			商货编号：&nbsp;JSQ—C50T2
		</li>
<br />
		<li>
			商品产地：&nbsp;中国大陆
		</li>
<br />
		<li>
			加湿方式：&nbsp;有雾加湿
		</li>
<br />
		<li>
			加水方式：&nbsp;普通加水
		</li>
<br />
		<li>
			容积：&nbsp;4L—5L
		</li>
	</ul>
<br />
</div>
<div class="cqwei" style="color:#848484;font-size:16px;text-align:center;white-space:normal;">
	<div class="cqwei_bt" style="margin:16px 0px;">
		————&nbsp;产品功能&nbsp;————
	</div>
	<div class="cqwei_img">
		<img src="https://work.idcode.org.cn/static/styles/common/images/pic_2.png" style="width: 300px;height: auto; margin: 0 auto; object-fit: scale-down;" />
	</div>
</div>
<div class="jzjie" style="color:#848484;font-size:16px;text-align:center;white-space:normal;">
	<div class="cjzjie_bt" style="margin:16px 0px;">
		————&nbsp;产品规格&nbsp;————
	</div>
	<div class="jzjie_img">
		<img src="https://work.idcode.org.cn/static/styles/common/images/pic_3.png" style="width: 300px;height: auto; margin: 0 auto; object-fit: scale-down;" />
	</div>
</div>`,
					
				}
			]
		};
	},
	computed: {},
	created() {},
	methods: {
		//  新建
		whitAdd() {
			this.$router.push({ path: '/GoodsCodeEdit', query: { template_id: 7 } });
		},
		// 编辑跳转
		Editor(row) {
			this.$router.push({
				path: '/GoodsCodeEdit',
				query: { tabimgurl: row.imgUrl, html: row.html, name: row.name, template_id: row.template_id }
			});
		}
	}
};
</script>
<style scoped lang="scss">
.contBox {
	width: 100%;
	height: 100%;
	background-color: #f0f0f0 !important;
}
.title {
	width: 46%;
	height: 50px;
	line-height: 50px;
	padding-top: 6px;
}
.addbox {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}
ul {
	display: flex;
	flex-direction: row;
}
ul li {
	width: 310px;
	height: 148px;
	background-color: #ffffff;
	border: 1px solid #e1e1e1;
	float: left;
	margin-right: 32px;
	margin-top: 30px;
	cursor: pointer;
}
.iconsAdd {
	font-size: 46px;
	color: #f0f0f0;
	margin-top: 20px;
}
.blankWhit p {
	color: #666666;
	text-align: center;
	font-size: 18px;
	margin-top: 20px;
}
.mb {
	padding: 30px 20px;
	display: flex;
}
.leftmb-img {
	width: 84px;
	height: 84px;
	overflow: hidden;
	flex: 1;
}
.Rightmb-text {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	align-items: flex-start;
	align-content: flex-start;
	margin-left: 10px;
	flex: 2;
}
// .Rightmb-text p {
// 	display: flex;
// 	justify-content: flex-start;
// 	color: #666666;
// 	font-size: 12px;
// 	width: 176px;
// 	margin-top: 10px;
// 	line-height: 1.8px;
// }
.p1{
	display: flex;
	justify-content: flex-start;
	color: #666666;
	font-size: 12px;
	width: 176px;
	margin-top: 10px;
	line-height: 1.8px;
}
.p2{
	display: flex;
	justify-content: flex-start;
	color: #666666;
	font-size: 12px;
	width: 176px;
	margin-top: 15px;
	line-height: 1.8px;
}
</style>
